'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _history = require('history');

var _reactRouterRedux = require('react-router-redux');

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _routes = require('routes');

var _routes2 = _interopRequireDefault(_routes);

var _configureStore = require('configureStore');

var _configureStore2 = _interopRequireDefault(_configureStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (Function.prototype.bind && window.console && _typeof(console.log) === 'object') {
  ['log', 'info', 'warn', 'error', 'assert', 'dir', 'clear', 'profile', 'profileEnd'].forEach(function (method) {
    console[method] = this.bind(console[method], console);
  }, Function.prototype.call);
}

window.console.log('Design: Chris Biron - biron.io');
window.console.log('Build: Max Bonhomme - bonhomme.lol');

// Create an enhanced history that syncs navigation events with the store
var history = (0, _reactRouter.useRouterHistory)(_history.createHistory)({
  basename: '/'
});

var store = (0, _configureStore2.default)();

// Create an enhanced history that syncs navigation events with the store
history = (0, _reactRouterRedux.syncHistoryWithStore)(history, store);

// Fix up prefixing
window.AudioContext = window.AudioContext || window.webkitAudioContext;
window.audioCTXT = new AudioContext();

_reactGa2.default.initialize('UA-96331808-1', { debug: false });

var logPageView = function logPageView() {
  _reactGa2.default.set({ page: window.location.pathname });
  _reactGa2.default.pageview(window.location.pathname);
};

_reactDom2.default.render(_react2.default.createElement(
  _reactRedux.Provider,
  { store: store },
  _react2.default.createElement(
    _reactRouter.Router,
    { history: history, onUpdate: logPageView },
    _routes2.default
  )
), document.getElementById('root'));


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 354
// module chunks = 1